import { api } from "@/api/client";
import type {
  AccountingTemplateDTO,
  DogovorDTO,
  KontragentCreateRequest,
  KontragentCreateResult,
  KontragentMappingSave,
  NomDTO,
  NomenclatureMappingSave,
  SuggestedMappingDTO,
} from "@/types/api";

export async function saveKontragentMapping(
  payload: KontragentMappingSave,
): Promise<void> {
  await api.post("/mappings/kontragent", payload);
}

export async function saveNomenclatureMapping(
  payload: NomenclatureMappingSave,
): Promise<void> {
  await api.post("/mappings/nomenclature", payload);
}

export async function searchNomenclature(q: string, top = 20): Promise<NomDTO[]> {
  const { data } = await api.get<NomDTO[]>("/odata/nomenclature/search", {
    params: { q, top },
  });
  return data;
}

export async function listDogovors(
  kontragentRefKey: string,
  organizationRefKey: string,
): Promise<DogovorDTO[]> {
  const { data } = await api.get<DogovorDTO[]>("/odata/dogovors", {
    params: {
      kontragent_ref_key: kontragentRefKey,
      organization_ref_key: organizationRefKey,
    },
  });
  return data;
}

export async function createKontragentIn1C(
  payload: KontragentCreateRequest,
): Promise<KontragentCreateResult> {
  const { data } = await api.post<KontragentCreateResult>(
    "/odata/kontragents/create",
    payload,
  );
  return data;
}

export async function batchCreateKontragents(
  payloads: KontragentCreateRequest[],
): Promise<KontragentCreateResult[]> {
  const { data } = await api.post<KontragentCreateResult[]>(
    "/odata/kontragents/batch-create",
    payloads,
  );
  return data;
}

export async function getSuggestedMapping(
  kontragentRefKey: string,
  organizationRefKey: string,
  nomenclatureRefKey: string,
): Promise<SuggestedMappingDTO | null> {
  try {
    const { data } = await api.get<SuggestedMappingDTO>(
      "/odata/suggest-mapping",
      {
        params: {
          kontragent_ref_key: kontragentRefKey,
          organization_ref_key: organizationRefKey,
          nomenclature_ref_key: nomenclatureRefKey,
        },
      },
    );
    return data;
  } catch {
    return null;
  }
}

export async function getAccountingTemplate(
  kontragentRefKey: string,
  organizationRefKey: string,
  dogovorRefKey: string,
): Promise<AccountingTemplateDTO> {
  const { data } = await api.get<AccountingTemplateDTO>(
    "/odata/accounting-template",
    {
      params: {
        kontragent_ref_key: kontragentRefKey,
        organization_ref_key: organizationRefKey,
        dogovor_ref_key: dogovorRefKey,
      },
    },
  );
  return data;
}
